export const SITE_ACL_OBJECTS = [
    'NewSiteComponent',
    'SiteListComponent',
    'SiteDetailComponent',
    'NewSectionComponent'
];
